export type BlogMeta = {
  slug: string;
  title: string;
  description: string;
  date: string; // YYYY-MM-DD
  tags?: string[];
};

export type BlogPostModule = {
  meta?: BlogMeta;
  default?: any; // React component
};

// Eagerly import ALL resources so there are no runtime chunk loads.
const modules = import.meta.glob<BlogPostModule>("../resources/**/*.{tsx,mdx}", {
  eager: true,
});

// Helpers
function slugFromPath(path: string) {
  const file = path.split("/").pop() || "";
  return file.replace(/\.(tsx|mdx)$/, "");
}
function titleFromSlug(slug: string) {
  return slug
    .replace(/[-_]+/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}
function isValidDate(s: string) {
  return /^\d{4}-\d{2}-\d{2}$/.test(s);
}

// Build unified list: prefer post.meta, otherwise infer basic meta
const ALL = Object.entries(modules)
  .map(([path, mod]) => {
    const slug = mod?.meta?.slug || slugFromPath(path);
    const title = mod?.meta?.title || titleFromSlug(slug);
    const description = mod?.meta?.description || "Article";
    const date = mod?.meta?.date && isValidDate(mod.meta.date) ? mod.meta.date : "2000-01-01";
    const Component = mod?.default;
    if (!Component) return null; // must have a default export to render
    return { slug, title, description, date, tags: mod?.meta?.tags || [], Component, __path: path };
  })
  .filter(Boolean) as (BlogMeta & { Component: any; __path: string })[];

// Newest first
const SORTED_POSTS = [...ALL].sort((a, b) => (a.date < b.date ? 1 : -1));

export function getAllPosts() {
  return SORTED_POSTS;
}
export function getRecentPosts(n: number) {
  return SORTED_POSTS.slice(0, n);
}
export function findPost(slug: string) {
  return SORTED_POSTS.find((p) => p.slug === slug);
}
